export default class Environment {
    static nodeEnv = process.env.NODE_ENV
    static apiUri = process.env.REACT_APP_API_URL
    static token = process.env.REACT_APP_TOKEN_API
}